import React, { useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.scss"
import "swiper/components/pagination/pagination.scss"
import "../../styles/styles.css"

// components
import VideoCard from "../videoCard"

// data
import videos from "../../data/videos"

const Releases = () => {
  let featured_videos = videos.filter((o) => o.featured === true)
  return (
    <section className="releases" id="releases">
      <div className="container">
        <header>
          <h1 className="main-heading">Featured Releases</h1>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Scelerisque
            auctor pulvinar urna eget. Libero porttitor lectus orci odio.
          </p>
        </header>
        <Swiper
          spaceBetween={0}
          breakpoints={{
            768: {
              width: 768,
              slidesPerView: 1,
            },
            1200: {
              width: 1200,
              slidesPerView: 2,
            },
          }}
          pagination
        >
          {featured_videos.map((video, index) => (
            <SwiperSlide>
              <VideoCard
                key={index}
                id={video.id}
                title={video.title}
                src={video.src}
                descr={video.descr}
                type={video.type}
                artist={video.artist}
                cover={video.coverImg}
                singThursday={video.singThursday}
              />
            </SwiperSlide>
          ))}
          <SwiperSlide>
            <div className="view-more">
              <Link to="/releases">View More</Link>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  )
}

export default Releases
